import { render } from "./CourseBooking.vue?vue&type=template&id=5c143465&scoped=true"
import script from "./CourseBooking.vue?vue&type=script&lang=js"
export * from "./CourseBooking.vue?vue&type=script&lang=js"

import "./CourseBooking.vue?vue&type=style&index=0&id=5c143465&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c143465"]])

export default __exports__